export const genSlug = (title: string) => {
  return title.replaceAll(/\n|%20|%0A| /g, '-').toLowerCase();
};
